import { useState } from "react";
import { HStack, VStack } from "../../../../shared/src/Components/Stacks.ts";
import styled, { css } from "styled-components";
import { IoIosArrowDown } from "react-icons/io";
import { truncate_text } from "../../../../shared/src/Functions/Utils.ts";

type Expandable = {
    shown: boolean;
};

const Expandable = styled.div<Expandable>`
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows var(--duration);

    & > div {
        overflow: hidden;
    }

    ${(props) =>
        props.shown &&
        css`
            grid-template-rows: 1fr;
        `}
`;

export const RotatingArrowContainer = styled.div<Expandable>`
    display: flex;
    width: auto;
    position: relative;
    transition: transform var(--duration);
    transform-origin: center center;
    ${(props) =>
        !props.shown &&
        css`
            transform: rotate(-90deg);
        `}
`;

const Container = styled.div`
    ${HStack} {
        cursor: pointer;
    }
`;

const Preview = styled.small`
    background: linear-gradient(to bottom, var(--disabled-text) 00%, var(--background) 100%);
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
    cursor: pointer;
`;

function ExpandableText({ title, text }: { title: string; text: string }) {
    const [show, setShow] = useState(false);

    const maxTextLength = 29;

    return (
        <>
            <Container>
                <VStack gap={"6"}>
                    {text.length > maxTextLength ? (
                        <>
                            <VStack gap={"6"} onClick={() => setShow(!show)}>
                                <HStack gap={"6"}>
                                    <p>{title}</p>
                                    <RotatingArrowContainer shown={show}>
                                        <IoIosArrowDown />
                                    </RotatingArrowContainer>
                                </HStack>

                                {!show && <Preview>{truncate_text(text, maxTextLength)}</Preview>}
                            </VStack>
                            <Expandable shown={show}>
                                <div>
                                    <small>{text}</small>
                                </div>
                            </Expandable>
                        </>
                    ) : (
                        <>
                            <p>{title}</p>
                            <small>{text}</small>
                        </>
                    )}
                </VStack>
            </Container>
        </>
    );
}

export default ExpandableText;
